import React, { useState } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { event } from '@uhg-abyss/web/tools/event';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { SubscribeToAPIModal } from '@src/common/SubscribeToAPIModal';
import { IllustrationBrand } from '@uhg-abyss/web/ui/IllustrationBrand';

const Wrapper = styled('div', {});

const Container = styled('div', {
  //minHeight: '400px',
  background: 'rgb(255, 255, 255)',
  borderRadius: '4px',
  width: '100%',
  display: 'flex',
  margin: '64px 0 0px 0',

  '@screen >= $xs': {
    flexDirection: 'column-reverse',
  },

  '@screen >= $lg': {
    flexDirection: 'row-reverse',
  },

  '@screen >= $xl': {
    flexDirection: 'row',
  },
});

const LeftCon = styled('div', {
  flexBasis: '50%',
  padding: '32px',
  margin: 'auto',
});

const RightCon = styled('div', {
  flexBasis: '50%',
  display: 'flex',
  alignItems: 'flex-end', // Align to bottom
  justifyContent: 'center', // Center horizontally
  overflow: 'hidden', // Clip any overflow

  '& svg, & img': {
    width: '100%',
    height: 'auto',
    display: 'block', // Removes inline spacing
  },
});

export const ConnectToOrganizationV2 = () => {
  const [showSubscribeAPIModal, setShowSubscribeAPIModal] = useState(false);
  const { navigate } = useRouter();

  const ScheduleMeetingTitle = 'Begin your API journey';
  const ScheduleMeetingSection =
    "We're excited to help you discover the right API solutions. Please answer a few brief questions about your organization and the services you provide so we can recommend the best approach. ";

  const ScheduleMeetingBtn = (
    <Button
      size="$lg"
      id="SubscribeToAPI"
      css={{ fontSize: '16px !important', fontWeight: '700 !important' }}
      onClick={() => {
        const jobName = 'request a meeting with an api consultant';
        event('JOB_START', {
          event,
          jobName,
        });
        navigate('/welcome/intake');
      }}
    >
      Get started
    </Button>
  );

  const ContainerSecTitle = styled('h3', {
    color: 'rgb(0, 38, 119)',
    fontSize: '32px ! important',
    fontWeight: 600,
    lineHeight: '40px',
    marginBottom: '16px',
  });

  const ContainerSecDescription = styled('p', {
    color: 'rgb(51, 51, 51)',
    fontSize: '15px',
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: '24px',
    marginBottom: '27px',
    //  whiteSpace: 'nowrap',
    width: '100%',
  });

  const ButtonsWrapper = styled('div', {
    marginTop: '24px',
    display: 'flex',
    gap: '16px',
    justifyContent: 'flex-start',
  });

  return (
    <Wrapper>
      <SubscribeToAPIModal
        showModal={showSubscribeAPIModal}
        modalOnClose={setShowSubscribeAPIModal}
      />
      <Container>
        <LeftCon>
          <ContainerSecTitle>{ScheduleMeetingTitle}</ContainerSecTitle>
          <ContainerSecDescription>
            {ScheduleMeetingSection}
          </ContainerSecDescription>
          <ButtonsWrapper>{ScheduleMeetingBtn}</ButtonsWrapper>
        </LeftCon>
        <RightCon>
          <IllustrationBrand
            illustration="keyboard"
            color="pacific"
            variant={1}
          />
        </RightCon>
      </Container>
    </Wrapper>
  );
};
